<template>
  <div class="single-test">
    <div class="head">
      <div class="response-head-title">{{ test.name }}</div>

      <!-- <div v-if="calculateTestStatus && hasPassed" class="passed">
        {{ $tr('responses.tabs.test.has_passed') }}
      </div>

      <div v-if="calculateTestStatus && !hasPassed" class="not-passed">
        {{ $tr('responses.tabs.test.has_not_passed') }}
      </div> -->

      <div v-if="score.count" class="info">
        <div
          v-if="test.is_print_screen"
          v-tooltip="{ content: $tr('response.preventPrintScreen'), classes: 'tight' }"
          class="anticheating-icon"
        >
          <img src="/static/images/elements/icon-anticheating.svg" />
        </div>

        <span class="count">
          {{ `${score.correct} ${$tr('responses.tabs.test.count')} ${score.count}` }}
        </span>

        <span class="percent">
          {{ `${score.percentCorrect} ${$tr('responses.tabs.test.percent')}` }}
        </span>
      </div>
    </div>

    <div v-if="duration" class="single-test__all-duration">
      {{ $tr('responses.tabs.test.total_questions_time') }} {{ duration }}
    </div>

    <div class="tabs__legend">
      <div class="tabs__legend-item">
        <span class="tabs__legend-item-icon">
          <div class="tabs__legend-item-icon-choice"><div></div></div>
        </span>
        <span>– {{ $tr('vacancy.tests.form.questions.types.choice') }}</span>
      </div>

      <div class="tabs__legend-item">
        <span class="tabs__legend-item-icon tabs__legend-item-icon-multichoice"><i class="icon-check"></i></span>
        <span>– {{ $tr('vacancy.tests.form.questions.types.multichoice') }}</span>
      </div>

      <div class="tabs__legend-item">
        <span class="tabs__legend-item-icon"><i class="icon-list"></i></span>
        <span>– {{ $tr('vacancy.tests.form.questions.types.value') }}</span>
      </div>

      <div class="tabs__legend-item">
        <span class="tabs__legend-item-icon"><i class="icon-file-upload-line"></i></span>
        <span>– {{ $tr('vacancy.tests.form.questions.types.file') }}</span>
      </div>
    </div>

    <div class="tabs">
      <div
        v-for="(question, index) in questions"
        :key="question.id"
        v-tooltip="{ content: $tr(`response.test.${question.isCorrect}`) }"
        class="tab"
        :class="[question.isCorrect, { selected: selectedQuestion && selectedQuestion.id === question.id }]"
        @click="selectQuestion(question)"
      >
        <span class="number">{{ index + 1 }}</span>

        <div v-if="question.type === 'choice'" class="tab__choice"><div></div></div>
        <div v-if="question.type === 'multichoice'" class="tab__multichoice"><i class="icon-check"></i></div>
        <div v-if="question.type === 'value'" class="tab__value"><i class="icon-list"></i></div>
        <div v-if="question.type === 'file'" class="tab__file"><i class="icon-file-upload-line"></i></div>
      </div>
    </div>

    <question v-if="selectedQuestion" :question="selectedQuestion" :one-page-test="onePageTest" />

    <screenshots
      v-if="isAnticheatingActive || (screenshots && screenshots.length)"
      :is-active="isAnticheatingActive"
      :question="selectedQuestion"
      :screenshots="screenshots"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Question from './Question';
import Screenshots from './Screenshots';
import { mapGetters, mapActions } from 'vuex';

const TYPE_ANSWER = {
  CORRECT: 'correct',
  PARTIALLY_CORRECT: 'partially-correct',
  INCORRECT: 'incorrect',
  NO_CORRECT_ANSWER: 'no-correct-answer',
  NOT_SELECTED: 'not-selected'
};

export default {
  name: 'SingleTestResult',

  components: { Question, Screenshots },

  props: {
    test: {
      type: Object,
      default: () => {}
    },

    response: {
      type: Object,
      default: () => {}
    },

    vacancyToken: {
      type: String,
      default: ''
    },

    isPublic: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedQuestion: null,
      modules: []
    };
  },

  computed: {
    ...mapGetters('landing', { landing: 'item' }),

    onePageTest() {
      if (!this.test) return false;

      return this.test.question_page_limit === 0;
    },

    duration() {
      let duration = 0;

      if (this.onePageTest) {
        duration = this.questions[0].duration;
      } else {
        this.questions.forEach(x => {
          duration += x.duration;
        });
      }

      return this.$moment.duration(duration, 'seconds').format('HH:mm:ss', { trim: false });
    },

    screenshots() {
      if (!this.test || !this.test.screenshots) return [];

      return this.test.screenshots;
    },

    isAnticheatingActive() {
      if (!this.isPublic) {
        if (!this.modules || !this.modules.length) return false;

        let isActive = false;

        this.modules.forEach(item => {
          if (item.id === 'anticheating') {
            isActive = item.is_active;
          }
        });

        return isActive;
      } else {
        if (!this.landing || !this.landing.active_modules || !this.landing.active_modules.length) {
          return false;
        }

        let isActive = false;

        this.landing.active_modules.forEach(item => {
          if (item.id === 'anticheating') {
            isActive = item.is_active;
          }

          if (item.child_modules && item.child_modules.length) {
            item.child_modules.forEach(submodule => {
              if (submodule.id === 'anticheating') {
                isActive = true;
              }
            });
          }
        });

        return isActive;
      }
    },

    questions() {
      return this.test.questions
        .slice()
        .map(question => {
          switch (question.type) {
            case 'choice':
              if (question.is_correct === true) {
                question.isCorrect = TYPE_ANSWER.CORRECT;
              } else if (question.is_correct === false && question.answers.some(x => x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              } else if (
                question.is_correct === null ||
                (question.is_correct === false && question.answers.every(x => !x.is_chosen))
              ) {
                question.isCorrect = TYPE_ANSWER.NO_CORRECT_ANSWER;
              } else {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              }
              break;

            case 'multichoice':
              if (question.is_correct === null && question.answers.every(x => x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.NO_CORRECT_ANSWER;
              } else if (question.is_correct === null && question.answers.every(x => !x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.NO_CORRECT_ANSWER;
              } else if (question.is_correct === null && question.answers.some(x => x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.NO_CORRECT_ANSWER;
              } else if (
                question.is_correct === false &&
                question.answers.some(x => x.is_valid && x.is_chosen) &&
                !question.answers.every(x => x.is_valid && x.is_chosen)
              ) {
                question.isCorrect = TYPE_ANSWER.PARTIALLY_CORRECT;
              } else if (question.is_correct === false && question.answers.every(x => !x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              } else if (question.is_correct === false && question.answers.every(x => x.is_valid === !x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              } else if (question.is_correct === true && question.answers.every(x => x.is_valid === x.is_chosen)) {
                question.isCorrect = TYPE_ANSWER.CORRECT;
              } else {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              }
              break;

            case 'value':
              if (question.is_correct === null) {
                question.isCorrect = TYPE_ANSWER.NO_CORRECT_ANSWER;
              } else if (question.is_correct === true) {
                question.isCorrect = TYPE_ANSWER.CORRECT;
              } else if (question.is_correct === false) {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              }
              break;

            case 'file':
              if (question.is_correct === true) {
                question.isCorrect = TYPE_ANSWER.CORRECT;
              } else if (question.is_correct === false) {
                question.isCorrect = TYPE_ANSWER.INCORRECT;
              }
              break;
            default:
              question.isCorrect = TYPE_ANSWER.INCORRECT;
          }

          return question;
        })
        .sort((q1, q2) => q1.priority - q2.priority);
    },

    score() {
      const count = this.questions.filter(x => x.is_correct !== null).length;
      const correct = this.questions.filter(x => x.is_correct === true).length;

      return { count, correct, percentCorrect: Math.round((correct / count) * 100) };
    }
  },

  async created() {
    if (this.questions.length) this.selectQuestion(this.questions[0]);

    if (!this.isPublic) {
      await this.fetchModules();
    } else {
      if (this.vacancyToken) {
        await this.fetchPublicVacancy(this.vacancyToken);
      }
    }

    if (this.$route.query.questionId !== undefined) {
      const question = this.questions.find(x => x.id == this.$route.query.questionId);

      if (question !== undefined) {
        this.selectQuestion(question);
      }
    }
  },

  methods: {
    ...mapActions('landing', { fetchPublicVacancy: 'load' }),

    selectQuestion(question) {
      // Это для того чтобы кнопка таба не "отжималась" если на нее нажать два раза (всегда показывается какой-то вопрос)
      if (this.selectedQuestion !== null && this.selectedQuestion.id === question.id) return;

      if (this.selectedQuestion && this.selectedQuestion.id == question.id) {
        this.selectedQuestion = null;
      } else {
        this.selectedQuestion = question;
      }
    },

    async fetchModules() {
      if (!this.response || !this.response.vacancy) return;

      await axios.get(`/1.0/vacancies/${this.response.vacancy.id}/modules`).then(response => {
        this.modules = response.data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.not-passed {
  color: $red;
}

.passed {
  color: $green;
}

.single-test {
  padding: 0 0 30px;

  .head {
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    @include mixin-text-header;
    margin-bottom: 25px;

    .info {
      background-color: transparent !important;
      border-color: transparent !important;
      display: flex;
      align-items: center;

      .count {
        display: inline-block;
        color: #9faab6;
        margin-right: 17px;
        max-width: 100px;
        overflow: hidden;
        vertical-align: bottom;
        text-overflow: ellipsis;
      }
    }
  }

  &__all-duration {
    @include mixin-text-header;
    margin-bottom: 25px;
  }

  .tabs {
    margin-bottom: 25px;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    width: 100%;

    .tab {
      box-sizing: border-box;
      width: 60px;
      height: 40px;
      margin: 0 1px 1px;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      border: 2px solid transparent;
      cursor: pointer;
      @include mixin-text-main;
      transition: height 0.2s;
      transition-delay: 0.3s;

      span {
        font-size: 15px;
      }

      &.correct {
        background: $green-normal;
        color: $white;
      }

      &.incorrect {
        background: $red-light;
        color: $white;
      }

      &.partially-correct {
        background: $orange-light;
        color: $white;
      }

      &.no-correct-answer {
        background: $main-dark-light;
        color: $white;
      }

      &.not-selected {
        background: $grey;
        color: $white;
      }

      &.selected {
        border: 2px solid $main-dark;
        transition: border 0.2s ease;
      }

      &__choice {
        position: absolute;
        bottom: 3px;
        left: 3px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $white;

        > div {
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background: $white;
        }
      }

      &__multichoice {
        position: absolute;
        bottom: 3px;
        left: 3px;
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $white;

        i {
          font-size: 8px;
        }
      }

      &__value {
        position: absolute;
        bottom: 3px;
        left: 3px;
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 12px;
        }
      }

      &__file {
        position: absolute;
        bottom: 3px;
        left: 3px;
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 12px;
        }
      }
    }

    &__legend {
      margin-bottom: 13px;
      display: flex;
      flex-wrap: wrap;
    }

    &__legend-item {
      @include mixin-text-tag;
      display: flex;
      align-items: center;
      margin-right: 15px;
      margin-bottom: 7px;
      line-height: 1.2;
      white-space: nowrap;

      i {
        font-size: 16px;
      }
    }

    &__legend-item-icon {
      margin-right: 5px;
      display: flex;
    }

    &__legend-item-icon-choice {
      width: 12px;
      height: 12px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $main-dark;

      > div {
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background: $main-dark;
      }
    }

    &__legend-item-icon-multichoice {
      width: 12px;
      height: 12px;
      border: 1px solid $main-dark;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 11px;
      }
    }
  }
}

.anticheating-icon {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.duration-block {
  margin-bottom: 15px;
}
</style>
